import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form4.css";

const Form4 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    mealPlan: "",
    foodPreference: "",
  });

  const [errors, setErrors] = useState({});

  const handleSelect = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const validate = () => {
    let err = {};

    if (!formData.mealPlan) {
      err.mealPlan = "Please select a meal plan";
    }

    if (!formData.foodPreference) {
      err.foodPreference = "Please select food preference";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

    const handleSubmit = (e) => {
      e.preventDefault();

      const isValid = validate();

      if (isValid) {
        navigate("/form5");
      }
    };

  return (
    <div className="meal-main">
      <div className="left-section">
        <h1>Meal Preferences</h1>
      </div>

      <div className="right-section">
        <form onSubmit={handleSubmit} className="meal-form">
          <label>Meal Plan</label>
          <div className="button-group">
            {[
              "No Meal",
              "Breakfast Only",
              "Breakfast + Dinner",
              "All Meal",
            ].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.mealPlan === item ? "active" : ""}`}
                onClick={() => handleSelect("mealPlan", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.mealPlan && <p className="error">{errors.mealPlan}</p>}

          <label>Food Preference</label>
          <div className="button-group">
            {["Veg", "Non-Veg"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.foodPreference === item ? "active" : ""}`}
                onClick={() => handleSelect("foodPreference", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.foodPreference && (
            <p className="error">{errors.foodPreference}</p>
          )}

          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="submit" className="next-btn">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form4;
